import { escapeHtml } from '@hapi/hoek';

const emojis = [
    { code: '100', url: '/img/emojis/100.png' },
    { code: '30max', url: '/img/emojis/30max.png' },
    { code: 'angry', url: '/img/emojis/angry.png' },
    { code: 'biblethump', url: '/img/emojis/biblethump.png' },
    { code: 'cant', url: '/img/emojis/cant.png' },
    { code: 'cashout', url: '/img/emojis/cashout.png' },
    { code: 'cry', url: '/img/emojis/cry.png' },
    { code: 'ct', url: '/img/emojis/ct.png' },
    { code: 'damn', url: '/img/emojis/damn.png' },
    { code: 'doit', url: '/img/emojis/doit.png' },
    { code: 'dont', url: '/img/emojis/dont.png' },
    { code: 'eyes', url: '/img/emojis/eyes.png' },
    { code: 'failsnipe', url: '/img/emojis/failsnipe.png' },
    { code: 'feelsbad', url: '/img/emojis/feelsbad.png' },
    { code: 'feelsbadman', url: '/img/emojis/feelsbadman.png' },
    { code: 'feelsgood', url: '/img/emojis/feelsgood.png' },
    { code: 'feelsgoodman', url: '/img/emojis/feelsgoodman.png' },
    { code: 'flexing', url: '/img/emojis/flexing.png' },
    { code: 'flip', url: '/img/emojis/flip.png' },
    { code: 'gg', url: '/img/emojis/gg.png' },
    { code: 'gl', url: '/img/emojis/gl.png' },
    { code: 'grin', url: '/img/emojis/grin.png' },
    { code: 'highroller', url: '/img/emojis/highroller.png' },
    { code: 'hightick', url: '/img/emojis/hightick.png' },
    { code: 'illuminati', url: '/img/emojis/illuminati.png' },
    { code: 'jebaited', url: '/img/emojis/jebaited.png' },
    { code: 'joinme', url: '/img/emojis/joinme.png' },
    { code: 'kappa', url: '/img/emojis/kappa.png' },
    { code: 'kiss', url: '/img/emojis/kiss.png' },
    { code: 'letsgo', url: '/img/emojis/letsgo.png' },
    { code: 'lit', url: '/img/emojis/lit.png' },
    { code: 'lose', url: '/img/emojis/lose.png' },
    { code: 'lowtick', url: '/img/emojis/lowtick.png' },
    { code: 'lul', url: '/img/emojis/lul.png' },
    { code: 'money', url: '/img/emojis/money.png' },
    { code: 'money_bag', url: '/img/emojis/money_bag.png' },
    { code: 'money_face', url: '/img/emojis/money_face.png' },
    { code: 'monkachrist', url: '/img/emojis/monkachrist.png' },
    { code: 'monkah', url: '/img/emojis/monkah.png' },
    { code: 'monkas', url: '/img/emojis/monkas.png' },
    { code: 'notlikethis', url: '/img/emojis/notlikethis.png' },
    { code: 'peach', url: '/img/emojis/peach.png' },
    { code: 'pepehands', url: '/img/emojis/pepehands.png' },
    { code: 'pogchamp', url: '/img/emojis/pogchamp.png' },
    { code: 'poop', url: '/img/emojis/poop.png' },
    { code: 'rekt', url: '/img/emojis/rekt.png' },
    { code: 'rip', url: '/img/emojis/rip.png' },
    { code: 't', url: '/img/emojis/t.png' },
    { code: 'vac', url: '/img/emojis/vac.png' },
    { code: 'win', url: '/img/emojis/win.png' },
];

export default emojis;

export function getEmoji(code: any) {
    return emojis.find((v) => v.code == code);
}

export function replaceEmojiCodesInText(text = '', escapeHTML = true) {
    if (escapeHTML) text = escapeHtml(text);
    emojis.map((v) => {
        text = text.replace(new RegExp(`:${v.code}:`, 'gui'), (r) => {
            const emoji = getEmoji(r.replace(/:/giu, ''));
            return `<img class="emoji" src=${emoji?.url} alt=${emoji?.code} />`;
        });
    });

    return text;
}
